import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { CvcTagListComponent } from './tag-list.component'

@NgModule({
  declarations: [CvcTagListComponent],
  imports: [CommonModule],
  exports: [CvcTagListComponent],
})
export class CvcTagListModule {}
